import NProgress from 'react-nprogress';

import { message } from 'antd';
import _ from 'lodash';

import axios from '~/constants/axiosConfig';
import { getQueryString } from '~/helpers/functions';

export async function getContratos(filtro) {
  let route = 'PropostaContrato';

  if (!_.isEmpty(filtro)) {
    route += getQueryString(filtro);
  }

  return axios
    .get(route)
    .then((response) => {
      const { status } = response;

      if (status === 200) {
        return response.data;
      }
      return {};
    })
    .catch(() => {
      return {};
    });
}

export async function putContrato(data) {
  const route = `PropostaContrato/${data.id}`;

  return axios
    .put(route, data)
    .then((response) => {
      const { status } = response;

      if (status === 200) {
        message.success('Registro editado com sucesso');
        return true;
      }

      message.error('Falha ao editar o registro');
      return false;
    })
    .catch(() => {
      message.error('Falha ao editar o registro');
      return false;
    });
}

export async function deleteContrato(id) {
  const route = `PropostaContrato/${id}`;

  return axios
    .delete(route)
    .then((response) => {
      const { status } = response;

      if (status === 200) {
        message.success('Registro excluído com sucesso');
        return true;
      }

      message.error('Falha ao excluir o registro');
      return false;
    })
    .catch(() => {
      message.error('Falha ao excluir o registro');
      return false;
    });
}

export async function downloadRelatorio(filtro) {
  NProgress.start();
  let route = `PropostaContrato/relatorio`;

  if (!_.isEmpty(filtro)) {
    route += getQueryString(filtro);
  }

  await axios
    .get(route, {
      responseType: 'blob',
    })
    .then((response) => {
      const { status } = response;

      if (status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `relatorio-proposta-contrato.xlsx`);
        document.body.appendChild(link);
        link.click();

        message.success('Download do relatório efetuado com sucesso');
        NProgress.done();
        return true;
      }

      message.error('Falha na tentativa de download do relatório');
      NProgress.done();
      return false;
    })
    .catch(() => {
      message.error('Falha na tentativa de download do relatório');
      NProgress.done();
      return false;
    });
}
